import { Avatar, TableCell, TableRow, Typography } from "@material-ui/core";
import BigNumber from "bignumber.js";
import { ethers } from "ethers";
import { useState } from "react";
import InterestRateFactoryPool from "src/assets/abis/poolMonitoring/InterestRateFactoryPool.json";
import { ONE_RAY } from "src/config/constants";
import { useConfigContext } from "src/context/config/configContext";
import { StepStatus, useAddAssetContext } from "src/context/monitoring/addAssetContext";
import { useProviderContext } from "src/ether-utils/context/providerContext";
import useNotify from "src/hooks/useNotify";
import { toFixed } from "src/services/utils";
import BaseAddPoolTable from "src/view/PoolMonitoring/Overview/AssetConfigOption/components/BaseAddPoolTable";
import BaseStep from "src/view/PoolMonitoring/Overview/AssetConfigOption/components/BaseStep";

export default function SecondStep({ targetProviderId, ...props }) {
  const { addresses } = useConfigContext();
  const { wallet } = useProviderContext();
  const { assets, stepStatus, setter } = useAddAssetContext();
  const [isLoading, setLoading] = useState(false);
  const { errorNotify, successNotify } = useNotify();

  const onConfirmClick = async () => {
    setLoading(true);
    const interestStruct = assets.map((item) => {
      return [
        item["address"],
        new BigNumber(item["utilizationOptimal"]).multipliedBy(ONE_RAY).toFixed(),
        new BigNumber(item["baseInterestRate"]).multipliedBy(ONE_RAY).toFixed(),
        new BigNumber(item["slope1"]).multipliedBy(ONE_RAY).toFixed(),
        new BigNumber(item["slope2"]).multipliedBy(ONE_RAY).toFixed(),
      ];
    });
    try {
      setter.setStepStatus((draft) => {
        draft["activeStatus"] = StepStatus.LOADING;
      });
      const interestRateContract = new ethers.Contract(
        addresses.interestRateStrategyFactoryAddress,
        InterestRateFactoryPool,
        wallet.signer
      );
      const _promise = await interestRateContract.initInterestRateStrategy(
        addresses.addressesProviderFactoryAddress,
        targetProviderId,
        interestStruct
      );
      await _promise.wait();
      setter.setStepStatus((draft) => {
        draft["activeStep"] = 2;
        draft["activeStatus"] = StepStatus.INIT;
        draft["selectedStep"] = 2;
      });
      successNotify("Finish Initialize Interest Rate Strategy");
      setLoading(false);
    } catch (err) {
      errorNotify(err.message);
      setter.setStepStatus((draft) => {
        draft["activeStatus"] = StepStatus.ERROR;
      });
      setLoading(false);
    }
  };

  const disabledBut =
    !(
      stepStatus.activeStep == 1 &&
      (stepStatus.activeStatus === StepStatus.INIT || stepStatus.activeStatus === StepStatus.ERROR)
    ) || isLoading;

  return (
    <BaseStep
      {...props}
      butProps={{
        disabled: disabledBut,
        onClick: onConfirmClick,
      }}
      isLoading={isLoading}
    >
      <BaseAddPoolTable
        tableHeaderConfig={[
          { text: "Asset" },
          { text: "Utilization Optimal" },
          { text: "Slope 1" },
          { text: "Slope 2" },
          { text: "Base Interest Rate" },
        ]}
        isEmpty={assets.length == 0}
      >
        {assets.map((asset, index) => (
          <TableRow key={index}>
            <TableCell style={{ display: "flex", alignItems: "center", position: "sticky", left: 0 }}>
              <Avatar style={{ marginRight: 10, width: "25px", height: "25px" }} src={asset.image}></Avatar>
              <Typography style={{ fontWeight: "bold" }}>{asset.symbol}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{`${toFixed(asset.utilizationOptimal * 100, 2)}%`}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{`${toFixed(asset.slope1 * 100, 2)}%`}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{`${toFixed(asset.slope2 * 100, 2)}%`}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{`${toFixed(asset.baseInterestRate * 100, 2)}%`}</Typography>
            </TableCell>
          </TableRow>
        ))}
      </BaseAddPoolTable>
    </BaseStep>
  );
}
